// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import App from './App'
import router from './router'
import 'element-ui/lib/theme-chalk/index.css'
import CollapseTransition from 'element-ui/lib/transitions/collapse-transition';
import 'babel-polyfill'
import "../static/style/style.less"
import "../static/style/hkPop.css"
Vue.use(ELEMENT)
Vue.use(VueI18n)
import 'element-ui/lib/theme-chalk/display.css';
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import zhLocale_TW from 'element-ui/lib/locale/lang/zh-TW'
import store from './store'

Vue.config.productionTip = false

const i18n = new VueI18n({
	locale: 'zh',
	messages: {
		'zh': Object.assign(require('./common/lang/zh.js'), zhLocale),
		'hk': Object.assign(require('./common/lang/hk.js'), zhLocale_TW)
	}
})
ELEMENT.i18n((key, value) => i18n.t(key, value))//element-ui结合vue-i18n@7.x国际化

import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

import VueTouchRipple from 'vue-touch-ripple'
import 'vue-touch-ripple/dist/vue-touch-ripple.css'
Vue.use(VueTouchRipple)

import MetaInfo from 'vue-meta-info'
Vue.use(MetaInfo)

import ga from 'vue-ga'//谷歌ga
ga(router, 'UA-101415456-1')
import VueGtm from 'vue-gtm'//谷歌gtm
Vue.use(VueGtm, {
  enabled: true,
  debug: true,
  vueRouter: router
});

/* eslint-disable no-new */
export default new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js